import { FormHelperText, Rating, RatingProps } from '@mui/material';
import { colors } from 'common/constants';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
type BaseRatingProps = RatingProps & {
    name: string;
};
const BaseRating: React.FC<BaseRatingProps> = ({ name, ...props }) => {
    const { control } = useFormContext();
    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState }) => (
                <>
                    <Rating
                        {...field}
                        onChange={(_, value) => field.onChange(value)}
                        {...props}
                    />
                    <FormHelperText
                        sx={{
                            fontSize: '14px',
                            marginLeft: 0,
                            color: `${colors.textError} !important`,
                            fontWeight: '400',
                        }}
                    >
                        {fieldState.error?.message}
                    </FormHelperText>
                </>
            )}
        />
    );
};

export default BaseRating;
